export default (state = [], {type, payload}) => {
    if ('FETCH_FILTERS' === type) {
        return payload.genders;
    }

    return state;
}
